<template>
  <div class="header-nav-bar">
    <div>
      <!-- begin:: obt heaer -->
      <div v-if="objBaseInfo.channelId === 'WEB'" class="obt-header_nav-menu">
        <ul>
          <li>
            <span>
              <a class="first" :href="env_url" target="_blank">{{ $t("HEADER.OBTNAV1") }}</a>
            </span>
          </li>
          <li v-if="showHotelListNotice">
            <a class="a-head-top" @click="hotelListNoticeDialogVisible = true">{{ noticeTitle }}</a>
          </li>
          <li>
            <a class="a-head-top" :class="{ 'a_selected': classShowEn }" @click="handleLanguage('en')">EN</a>
            <strong style="cursor: default; padding: 0 0.3rem">/</strong>
            <a class="a-head-top" :class="{ 'a_selected': !classShowEn }" @click="handleLanguage('zh')">简中</a>
          </li>
          <li>
            <a class="a-head-top" href="javascript:void(0);" @click="getSSOUrl('Fl028')" target="_self">{{
              $t("HEADER.OBTNAV2", { number: 0 })
            }}</a>
          </li>
          <li>
            <router-link v-if="isUat" to="#" @click="getSSOUrl('Fl004')" class="a-head-top">{{
              $t("HEADER.OBTNAV3")
            }}</router-link>
            <router-link v-else class="a-head-top" :to="{ name: 'orderList' }">{{
              $t("HEADER.OBTNAV3")
            }}</router-link>
          </li>
          <li>
            <el-tooltip placement="bottom" effect="light">
              <template #content>
                <div style="font-size: 1.5rem">
                  <el-row v-for="(item, index) in objBaseInfo.customerTcs" :key="'TCIndex' + index">
                    <el-col v-if="objBaseInfo.destinationType && objBaseInfo.destinationType.indexOf(item.isDomc) > -1" :span="24">{{
                        $i18n.locale == "zh" ? item.keyName : item.keyENName
                      }}：{{ item.keyValue }}</el-col>
                  </el-row>
                </div>
              </template>
              <router-link class="a-head-top" to="#">
                {{ $t("HEADER.OBTNAV4") }}
              </router-link>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <!-- end:: obt heaer -->
      <div class="header-nav" v-if="objBaseInfo.channelId === 'WEB'">
        <div class="header-nav-bar-menu">
          <img class="nav-bar-logo" alt="logo" src="@/assets/img/logo.png" />
          
          <!-- 添加菜单加载状态指示器 -->
          <div v-if="menuLoading" class="menu-loading">
            <el-icon class="is-loading"></el-icon>
          </div>
          
          <template v-else>
            <el-menu v-if="menuList && menuList.length > 0" :default-active="defaultActive" mode="horizontal" :ellipsis="false">
              <el-menu-item v-for="(menu, index) in menuList" :key="menu.menuCode" :index="index.toString()">
                <a v-if="menu.menuCode == 'FL04'" :href="urlAb + '?sourceType=OBT&destinationType=D'" style="font-weight: bold;">{{
                  $i18n.locale == "zh" ? menu.menuName : menu.menuNameEn
                }}</a>
                
                <a v-else-if="menu.menuCode == 'FL10'" :href="urlAb + '?sourceType=OBT&destinationType=I'" style="font-weight: bold;">{{
                  $i18n.locale == "zh" ? menu.menuName : menu.menuNameEn
                }}</a>
                
                <span v-else @click="getSSOUrl(menu.menuCode)" style="font-weight: bold;">{{
                  $i18n.locale == "zh" ? menu.menuName : menu.menuNameEn
                }}</span>
              </el-menu-item>
            </el-menu>
          </template>
        </div>
        
        <div class="topbar-item" style="display: none">
          <button class="btn-icon" @click="handleLanguage1" title="">
            <svg-icon :icon-class="$i18n.locale == 'en' ? 'lang-en' : 'lang-zh'"></svg-icon>
          </button>
        </div>
        
        <div class="topbar">
          <div class="topbar-item">
            <span class="text-username">{{
              $t("HEADER.BARITEM1", { msg: loginName })
            }}</span>
            <span class="text-username-label">{{
              userNameInitials
            }}</span>
          </div>
        </div>
      </div>
      
      <EjectAnnouncement :centerDialogVisible="hotelListNoticeDialogVisible" @setAnnouncementFlag="setAnnouncementFlag"></EjectAnnouncement>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import {
  getUserGetUserMenuList,
  userLoginOut,
  jumpLogin,
  sanitizeJumpUrl,
} from "../../api/platformData.js";
import { Locale } from "vant";
import EjectAnnouncement from "../../components/EjectAnnouncement.vue";
import { ElLoading } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import en from 'element-plus/es/locale/lang/en';
import { updateRouteTitles } from '../../router/index.js';

export default {
  name: "Header",
  components: {
    EjectAnnouncement,
  },
  inject: ['elLocale'],
  data() {
    return {
      loginName: "Canny",
      defaultActive: "0",
      menuList: [],
      isUat: true,
      env_url: "",
      classShowEn: this.$i18n.locale == "en" ? true : false,
      showHotelListNotice: false,
      hotelListNoticeDialogVisible: false,
      noticeTitle: "",
      urlAb: "",
      objBaseInfo: {}, // 存储全局属性
      menuLoading: false, // 添加菜单加载状态
    };
  },
  methods: {
    async getSSOUrl(menuCode) {
      this.$parent.menuAllloading = true;
      let jumpParams = {
        params: {
          jumpType: this.objBaseInfo.jumpType,
          menuFunCode: menuCode,
        },
      };
      await jumpLogin(jumpParams)
        .then((res) => {
          this.$parent.menuAllloading = false;
          if (res.code == 200) {
            this.navigateToSafeUrl(res.data);
          } else {
            console.log("OBT菜单转sso跳转失败", res);
          }
        })
        .catch((err) => {
          this.$parent.menuAllloading = false;
          console.log("OBT菜单转sso跳转失败", err.objError);
        });
    },
    getUrlPara: function () {
      // var url = document.location.toString();
      // var arrUrl = url.split("?");
      // var para = arrUrl[0];
      if (window.location.href.includes('sit')) {
        this.urlAb = window.location.origin + "/sit";
      } else {
        this.urlAb = window.location.origin;
      }
    },
    //获取菜单列表
    async getMenu() {
      this.menuLoading = true;
      let params = { params: { page: 1, per_page: 1000 } };
      
      try {
        const res = await getUserGetUserMenuList(params);
        
        if (res.code == 200) {
          if (res.data.error.code != 0) {
            console.log("获取菜单列表请求失败, code:" + res.data.error.code, res.data.error.message);
          } else {
            this.menuList = res.data.menuList.userMenus;
            
            if (this.menuList && this.menuList.length > 0) {
              // 优化默认激活项设置逻辑
              let activeIndex = 0;
              for (let i = 0; i < this.menuList.length; i++) {
                const element = this.menuList[i];
                if ((element.menuCode == "FL04" && this.objBaseInfo.destinationType == "D") ||
                    (element.menuCode == "FL10" && this.objBaseInfo.destinationType == "I")) {
                  activeIndex = i;
                  break;
                }
              }
              this.defaultActive = activeIndex.toString();
            }
          }
        } else {
          console.log("获取菜单列表请求失败, code:" + res.code, res.message);
        }
      } catch (err) {
        console.log("获取菜单列表请求失败", err.objError);
      } finally {
        this.menuLoading = false;
      }
    },
    
    handleLanguage(language) {
      if (this.$i18n.locale === language) return;
       setTimeout(() => {
        updateRouteTitles()
      }, 100)
      localStorage.setItem("language", language);
      this.$i18n.locale = language;
      this.classShowEn = language === "en";
      // 切换 Element Plus 语言
      this.elLocale.value = language === 'en' ? en : zhCn;
      console.log('elLocale updated to:', this.elLocale.value);
      // 更新通知标题
      const uiAnnoucementSettings = this.objBaseInfo.uiAnnoucementSettings;
      if (uiAnnoucementSettings && uiAnnoucementSettings[0]?.isNavigationBarLabel) {
        this.noticeTitle = uiAnnoucementSettings[0].title[
          language === "en" ? language : "zh-CN"
        ];
      }
      // 更新 Vant 语言
      Locale.use(language);
    },
    
    handleLanguage1(event) {
      const locale = this.$i18n.locale;
      const newLocale = locale === "en" ? "zh" : "en";
      
      event.target.setAttribute("xlink:href", `#icon-lang-${newLocale}`);
      localStorage.setItem("language", newLocale);
      this.$i18n.locale = newLocale;
      this.classShowEn = newLocale === "en";
      
      Locale.use(newLocale);
    },
    
    // 移除未使用的 handleNavMenu 方法
    
    async handleLogOutClick() {
      await userLoginOut()
        .then((res) => {
          if (res.code == 200) {
            this.navigateToSafeUrl(res.data);
          } else {
            console.log("退出 请求失败, code:" + res.code, res.message);
          }
        })
        .catch((error) => {
          console.log("退出 请求失败", error.objError);
        });
    },
    
    //Announcement
    setAnnouncementFlag(value) {
      this.hotelListNoticeDialogVisible = value;
    },
    navigateToSafeUrl(rawUrl) {
      const safeUrl = sanitizeJumpUrl(rawUrl);
      if (safeUrl) {
        const redirectLink = document.createElement("a");
        redirectLink.href = safeUrl;
        redirectLink.target = "_self";
        redirectLink.rel = "noopener noreferrer";
        redirectLink.referrerPolicy = "no-referrer";
        redirectLink.click();
      }
    },

  },
  computed: {
    getName() {
      if (this.$i18n.locale === "en") {
        return this.$objBaseInfo.userNameQuanPin
          ? this.$objBaseInfo.userNameQuanPin.replace("/", " ")
          : "";
      } else {
        return this.$objBaseInfo.userName;
      }
    },
    // classShowEn: function () {
    //   return this.$i18n.locale == "en" ? true : false;
    // },
    userNameInitials() {
      const userNameQuanPin = this.$objBaseInfo.userNameQuanPin || "";
      if (!userNameQuanPin) return "";

      const separatorIndex = userNameQuanPin.indexOf("/");
      if (separatorIndex !== -1) {
        return userNameQuanPin.substr(0, 1) + userNameQuanPin.substr(separatorIndex + 1, 1);
      }

      return userNameQuanPin.substr(0, 1);
    },
  },
  mounted() {
    // 获取全局属性
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    
    this.isUat = true;
    this.loginName = this.getName;
    this.getMenu();
    this.getUrlPara();
  },
  
  updated() {
    this.env_url = this.$t("COMMONPARAM.NAV1URL");
    this.loginName = this.getName;
  },
  
  watch: {
    //判断来源：Result页面显示 列表页公告
    $route() {
      if ((this.$route.name == "Result" || this.$route.name == "gaodeMap") && 
          this.objBaseInfo.sourceType == "OBT") {
        
        const uiAnnoucementSettings = this.objBaseInfo.uiAnnoucementSettings;
        if (uiAnnoucementSettings && uiAnnoucementSettings.length > 0) {
          if (uiAnnoucementSettings[0].isNavigationBarLabel) {
            this.showHotelListNotice = true;
            this.noticeTitle = uiAnnoucementSettings[0].title[
              this.$i18n.locale == "en" ? this.$i18n.locale : "zh-CN"
            ];
          }
        }
      } else {
        this.showHotelListNotice = false;
      }
    },
  },
};
</script>

<style>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .obt-header_nav-menu,
  .el-menu--horizontal {
    display: none;
  }
}

/* 添加菜单加载样式 */
.menu-loading {
  display: flex;
  align-items: center;
  padding: 0 20px;
  color: #606266;
}

.menu-loading span {
  margin-left: 8px;
}

.menu-empty {
  padding: 0 20px;
  color: #909399;
}
</style>

<style lang="stylus" scoped>
.header-nav-bar {
  border-top: solid 1rem $btn-bg-color;
  background-color: #fff;
  position: relative;
  z-index: 1;
}

.header-nav {
  padding: 0rem 4rem;
  height: 8rem;
  line-height: 8rem;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  max-width: 1320px;
  margin: auto;
}

.obt-header_nav-menu {
  height: 3.5rem;
  max-width: 1440px;
  margin: auto;

  ul {
    display: flex;
    justify-content: flex-end;
    padding: 0.8rem;
    color: $btn-bg-color;
    font-size: 1.3rem;

    li {
      padding: 0 1rem;
      cursor: pointer;

      span {
        background-color: $btn-bg-color;
        color: #fff;
        padding: 0 0.4rem;
      }
    }

    li:nth-child(odd):not(:last-child) {
      border-right: 0.1rem solid $font-color;
    }

    li:nth-child(even):not(:last-child) {
      border-right: 0.2rem solid $font-color;
    }
  }
}

.header-nav-bar-menu {
  display: flex;
  align-items: center;

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
  }
}

.nav-bar-logo {
  margin-top: .5rem;
  margin-right: 2rem;
  width: 9rem;
  height: 4rem;
}

.header-nav-ul-a:hover {
  color: $text-fill-color;
}

.topbar {
  display: flex;
  min-width: 30rem;
  justify-content: flex-end;
}

.topbar-item {
  align-content: center;

  button {
    font-size: 3rem;
    margin-right: 1rem;
    vertical-align: -0.2em;
    padding: 0.5rem;
    border: 0;
    cursor: pointer;
  }
}

.text-username {
  float: left;
  font-size: 1.8rem;
  font-weight: 600;
  padding-right: 1rem;
  line-height: 8.5rem;
  text-transform: capitalize;
}

.text-username-label {
  margin-top: 1.5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2.5rem;
  width: 5rem;
  height: 5rem;
  background-color: $btn-bg-color;
  font-size: 2rem;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 28px;
  text-transform: uppercase;
}

.first:link {
  color: white;
}

.first:visited {
  color: white;
}

.a-head-top {
  color: $btn-bg-color;
  text-decoration: none;
  transition: border-bottom 0.2s ease;
}

.a-head-top:hover {
  border-bottom: 0.15rem solid;
  border-color: $btn-bg-color;
}

.a_selected {
  font-weight: 600;
}

.el-menu--horizontal>.el-menu-item {
  height: 3.5rem;
  line-height: 4rem;
  color: #909399;
}

.el-menu-item {
  font-size: 1.8rem;
  padding: 0 1rem;
}

.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 2px solid $btn-bg-color;
  color: #303133 !important;
}

/* 响应式设计优化 */
@media screen and (max-width: 1200px) {
  .header-nav {
    padding: 0 2rem;
  }
  
  .topbar {
    min-width: 25rem;
  }
}
</style>